import styled from 'styled-components';

export default styled.button.attrs({ type: 'button' })<{ action: 'confirm' | 'cancel' }>`
   background-color: ${({ action, theme }) => (action === 'confirm' ? theme.secondaryBlueLight : theme.secondaryRed)};
   padding: 7px 10px;
   border-radius: 10px;
   font-size: 1.2em;
   font-weight: bold;
   margin: 0 1.5em;
   border: none;
   color: ${({ theme }) => theme.primaryWhite};
   &:hover {
      background-color: ${({ action, theme }) => (action === 'confirm' ? theme.secondaryBlueDark : theme.primaryRed)};
      cursor: pointer;
   }

   @media only screen and (max-width: 930px) {
      margin: 0 10px;
   }
`;
